interface Filters {
  status: string
  company: string
  site: string
}

interface Props {
  filters: Filters
  companies: string[]
  sites: string[]
  onChange: (filters: Filters) => void
}

export default function NodeFilterBar({ filters, companies, sites, onChange }: Props) {
  function set(key: keyof Filters, value: string) {
    const nextFilters = { ...filters, [key]: value }
    if (key === 'company') nextFilters.site = ''
    onChange(nextFilters)
  }

  return (
    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 20 }}>
      <select
        value={filters.status}
        onChange={(e) => set('status', e.target.value)}
        style={selectStyle}
      >
        <option value="">All statuses</option>
        <option value="online">Online</option>
        <option value="offline">Offline</option>
        <option value="warning">Warning</option>
      </select>

      <select
        value={filters.company}
        onChange={(e) => set('company', e.target.value)}
        style={selectStyle}
      >
        <option value="">All companies</option>
        {companies.map((s) => (
          <option key={s} value={s}>{s}</option>
        ))}
      </select>

      <select
        value={filters.site}
        onChange={(e) => set('site', e.target.value)}
        style={selectStyle}
      >
        <option value="">All sites/areas</option>
        {sites.map((s) => (
          <option key={s} value={s}>{s}</option>
        ))}
      </select>
    </div>
  )
}

const selectStyle: React.CSSProperties = {
  padding: '6px 10px',
  border: '1px solid #d0d0d8',
  borderRadius: 4,
  fontSize: 13,
  background: '#fff',
  cursor: 'pointer',
  fontFamily: 'inherit',
}
